import styled from '@emotion/styled';
import { Drawer, DrawerProps } from '@mui/material';

export const SafeAreaDrawer = styled(Drawer)<{ anchor?: DrawerProps['anchor']; zIndex?: Number }>`
  ${props => `padding-${props.anchor ?? ''}: env(safe-area-inset-${props.anchor ?? ''}, 0);`};
  ${props => props.zIndex && `z-index: ${props.zIndex.toString()};`};
`;
